import React, { useCallback, useState } from 'react';
import { map, prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { Link } from 'js/components/common/Link';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';
import { useFormatter } from 'js/hooks/useFormatter';
import { usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import GamesViewMini from 'js/components/common/GamesView/GamesViewMini';
import ConvertPopup from './ConvertPopup';
import style from './index.scss';

export default (props) => {
    const formatter = useFormatter();
    const t = usePortletTranslations();
    const { convert } = usePortletSelector(prop('balances'));
    const { card, conversion = {}, expanded, onExpand } = props;
    const lang = useUserSelector(prop('lang'));
    const currencyCode = useUserSelector(prop('currencyCode'));
    const userLanguageCode = (lang || '').split('_')[0].toUpperCase();
    const {
        bonusTranslations = [],
        gamingContext = {},
        bonusTcUrl = '',
        description = '',
        marketingName = '',
        code,
        name,
        playType
    } = card;
    const { conversionRate, minimumConversion } = map(Number, conversion);
    const { conversionRuleId } = conversion;
    const bonusText = bonusTranslations.find(bonus => bonus.languageCode === userLanguageCode) || {};
    const isCash = code === 'cash';
    const isConvertEnabled = convert >= Math.max(minimumConversion, conversionRate);
    const isConvertRateCash = playType !== 'goldenchips' && playType !== 'freespins';
    const [showConvertPopup, setShowConvertPopup] = useState(false);
    const toggleConvertPopup = useCallback(() => setShowConvertPopup(!showConvertPopup), [showConvertPopup]);

    const onInfoBtnClick = useCallback(() => {
        onExpand(conversionRuleId);
    }, [onExpand, conversionRuleId]);

    return (
        <div className={style.cardContainer}>
            <div className={style.cardTitle}>
                {isCash
                    ? t('cash')
                    : bonusText.marketingName || marketingName || name
                }
            </div>
            <p className={style.cardDetails}>
                {`${t('convertionRate')} `}
                <span className={style.cardConversionRate}>
                {`${conversionRate} pts = `}
                    {isConvertRateCash
                        ? formatter.formatCurrency(1, { currencyCode, precision: 0 })
                        : `1 ${t(playType)}`
                    }
            </span>
                <br />
                {`${t('minimumConvertion')} `}
                <span className={style.cardConversionRate}>{minimumConversion} pts</span>
            </p>
            <div className={style.buttons}>
                {!isCash && (
                    <Button
                        view="secondary"
                        color="info"
                        size="medium"
                        className={style.infoBtn}
                        onClick={onInfoBtnClick}
                    >
                        {expanded ? t('buttonShowLess') : t('buttonShowMore')}
                        <Icon
                            type="showMoreArrow"
                            className={`${style.icon} ${expanded ? style.iconExpanded : ''}`}
                        />
                    </Button>
                )}
                <Button size="medium"
                    className={style.convertBtn}
                    disabled={!isConvertEnabled}
                    onClick={toggleConvertPopup}
                >
                    {t('buttonConvert')}
                </Button>
            </div>
            {!isCash && (
                <div className={`${style.more} ${expanded ? style.expanded : ''}`}>
                    {gamingContext.selectedGames && (
                        <GamesViewMini
                            gameCodes={gamingContext.selectedGames}
                            isVisible={expanded}
                        />
                    )}
                    <p>{bonusText.description || description}</p>
                    {bonusTcUrl && <Link href={bonusTcUrl} inNewWindow={true}>{t('tc')}</Link>}
                </div>
            )}
            {showConvertPopup && <ConvertPopup {...{ toggleConvertPopup, conversionRuleId }} />}
        </div>
    );
};
